@if (dataLoaded) {
  <div class="tea-create-pickup">
    <div class="steps">
      <div class="list-steps">
        <app-steps [steps]="formActivityPickupService.steps" [currentStep]="0"></app-steps>
      </div>
    </div>
    <form [formGroup]="form">
      <div class="form-horizontal">
        <div
          class="form-group space-input"
          [class.space-input-edit]="
            (isEditPickup && !formActivityPickupService.space) || form.controls['space_id'].hasError('equalForbidValue')
          "
        >
          <div class="form-filter">
            <div class="label-title">
              <label class="label" id="pickupInvalid">公開先スペース</label>
              <span class="spen-mod-badge is-red">必須</span>
            </div>
            @if (formActivityPickupService.space) {
              <div class="space-info">
                <div class="space-info-edit">
                  <div class="block-color" [style.background-color]="formActivityPickupService.space.color_code"></div>
                  <span class="truncate-text">{{ formActivityPickupService.space.name }}</span>
                  <a class="spen-util-link" (click)="findSpace()">変更する</a>
                </div>
                @if (formErrors['space_id']) {
                  <div class="input-space-offset" [class.edit-id-invalid]="form.controls['space_id'].hasError('equalForbidValue')">
                    <div class="spen-mod-error-content error-popup">
                      {{ formErrors['space_id'].join(' ') }}
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="space-content">
                @if (formActivityPickupService.spaces.length > 0) {
                  <div class="list-space">
                    @for (space of formActivityPickupService.spaces; track space.id) {
                      <div class="selecting-space">
                        <div class="space-color" [style.background-color]="space.color_code"></div>
                        <p class="space-name truncate-text">{{ space.name }}</p>
                        <a class="spen-util-link" (click)="removeSpace(space)">削除する</a>
                      </div>
                    }
                  </div>
                }
                <label
                  class="space-select-box"
                  [class.remove-border-top]="formActivityPickupService.spaces.length > 0"
                  (click)="findSpace()"
                >
                  <i class="fa fa-plus-circle"></i>
                  <span class="spen-util-link">{{ formActivityPickupService.spaces.length === 0 ? '選択する' : '追加する' }}</span>
                </label>
                <input type="hidden" formControlName="space_ids" />
                @if (formErrors['space_ids']) {
                  <div class="error-popup">
                    <div class="spen-mod-error-content">
                      {{ formErrors['space_ids'].join(' ') }}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="form-group form-input step-1">
          <div class="form-filter align-center">
            <div class="label-title">
              <label class="label">ピックアップ表示期間</label>
            </div>
            <div class="flex-container">
              <div class="input-date">
                <app-datepicker
                  [isPopup]="true"
                  [isFixedDropdown]="true"
                  (modelChange)="updateEndTime($event)"
                  [selectedDate]="formActivityPickupService.endTime"
                  [includeResponsive]="true"
                ></app-datepicker>
              </div>
              <div class="label-date">
                <span class="until-label">まで</span>
              </div>
            </div>
          </div>
          @if (formErrors['end_time']) {
            <div class="input-space-offset">
              <div class="spen-mod-error-content error-popup end-time-error">
                {{ formErrors['end_time'].join(' ') }}
              </div>
            </div>
          }
        </div>
        <div class="form-group form-input">
          <div class="form-filter">
            <div class="label-title title-self-center">
              <label class="label">匿名設定</label>
            </div>
            <div class="input-space group-radio">
              <label class="spen-mod-radio">
                <input
                  class="radio"
                  [checked]="!form.get('is_anonymous').value"
                  type="radio"
                  [value]="false"
                  formControlName="is_anonymous"
                />
                <i class="fa"></i>
                <span class="text">匿名にしない</span>
              </label>
              @if (layoutService.isTabletDownView.value) {
                <div class="clear-fix"></div>
              }
              <label class="spen-mod-radio">
                <input
                  class="radio"
                  [checked]="!!form.get('is_anonymous').value"
                  type="radio"
                  [value]="true"
                  formControlName="is_anonymous"
                />
                <i class="fa"></i>
                <span class="text">匿名にする</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-group form-input textarea-input">
          <div class="form-filter">
            <div class="label-title">
              <label class="label">説明</label>
            </div>
            <div class="input-space input-textarea">
              <textarea
                class="spen-mod-input-text"
                [appPlaceholder]="'例）できるようになったことや成長したことを踏まえて、次の学びにつながるように書かれていて素晴らしいです。'"
                formControlName="reason"
                maxlength="1000"
              >
              </textarea>
              @if (formErrors['reason']) {
                <div class="spen-mod-error-content error-popup">
                  {{ formErrors['reason'].join(' ') }}
                </div>
              }
            </div>
          </div>
        </div>
        @if (!layoutService.isTabletDownView.value) {
          <div class="list-button-submit">
            <button type="button" class="spen-mod-btn" (click)="goBack()" [disabled]="disabledSubmit">戻る</button>
            <div class="delete-pickup">
              @if (isEditPickup()) {
                <div class="delete-button" (click)="deletePickup()">
                  <i class="fa fa-trash-o"></i>
                  <span class="spen-util-link">ピックアップを取り消す</span>
                </div>
              }
              <button type="button" (click)="onSubmit()" [disabled]="disabledSubmit" class="spen-mod-btn is-primary">確認へ</button>
            </div>
          </div>
        } @else {
          <div class="list-button-submit">
            @if (isEditPickup()) {
              <div class="delete-pickup">
                <div class="delete-button" (click)="deletePickup()">
                  <i class="fa fa-trash-o"></i>
                  <span class="spen-util-link">ピックアップを取り消す</span>
                </div>
              </div>
            }
            <button type="button" class="spen-mod-btn" (click)="goBack()">戻る</button>
            <button type="button" (click)="onSubmit()" class="spen-mod-btn is-primary">確認へ</button>
          </div>
        }
      </div>
    </form>
  </div>
} @else {
  <div class="spen-mod-flex-loading">
    <div class="loading-icon"></div>
  </div>
}

@if (isShowSearchModalMulti) {
  <app-search-multi-space
    (closeEvent)="closeSearch()"
    (submitEvent)="onSelectMultiSpace($event)"
    [selectedSpaces]="formActivityPickupService.spaces"
    [activityRecordId]="formActivityPickupService.activityRecordId"
  >
  </app-search-multi-space>
}

@if (isShowSearchModalSingle) {
  <app-search-single-space
    (closeEvent)="closeSearch()"
    (submitEvent)="onSelectSpace($event)"
    [selectedSpace]="formActivityPickupService.space"
    [activityRecordId]="formActivityPickupService.activityRecordId"
    [spaceEditId]="formActivityPickupService.originalSpaceEditId"
  >
  </app-search-single-space>
}
